import FacilityConfigForm from "./FacilityConfigForm"

export default FacilityConfigForm